export { FavoriteIcon } from './FavoriteIcon';
